"use strict";

/**
 * Client-side JavaScript helper starting point (for injecting polyfills and global styles)
 */
// inject polyfills for es5 support (e.g. promises node<0.12, es6 support) etc.
require("babel-polyfill");
// fixes: Uncaught TypeError: Cannot read property 'async' of undefined
// https://github.com/agraboso/redux-api-middleware/issues/83
var regeneratorRuntime = require("babel-runtime/regenerator");
if (!regeneratorRuntime.default) {
    regeneratorRuntime.default = regeneratorRuntime;
}
// include the intl polyfil for browsers that don't support it (safari)
require("intl");
require("intl/locale-data/jsonp/de.js"); // include the german locale data for this polyfil
// enables a fetch polyfill that works consistent on browser and server environments
// standard: https://fetch.spec.whatwg.org/
require("isomorphic-fetch");
// inject polyfill console.xx to avoid console related errors in old browser environments.
if (__DEVELOPMENT__) {
    require("./core/avoidConsoleErrors");
}
// import global application styles (styles in src/assets/styles/*.*ss are not locally scoped)
require("./assets/styles/global.less");
require("react-tap-event-plugin")();
// REACT-WIDGETS only needed polyfill
// localicer configuration (to be able to use the Date & Time Picker from react-widgets) --> http://jquense.github.io/react-widgets/docs/#/i18n
var moment = require("moment");
require("moment/locale/de-at"); // directly inject the locale to use
var momentLocalizer = require("react-widgets/lib/localizers/moment");
momentLocalizer(moment); // finally set the react-widgets internal localizer up!


/*****************
 ** WEBPACK FOOTER
 ** ./src/preload.ts
 ** module id = 1314
 ** module chunks = 0
 **/